import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import { useContext, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

function Splash() {
  let { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      const token = localStorage.getItem("token");
      const refreshToken = localStorage.getItem("refresh_token");

      const isAuthenticated = !isEmpty(user) || (!!token && !!refreshToken);
      if (isAuthenticated) {
        navigate("/dashboard");
      } else {
        navigate("/login");
      }
    }, 1000);

  }, [navigate, user]);

  return (
    <div className="w-full flex text-center justify-center h-full">
      <img src="images/whitelogo.svg" className="w-[20rem] md:w-[15rem] hidden dark:block" alt="ALPAY LOGO" />
      <img src="images/logo.svg" className="w-[20rem] md:w-[15rem] block dark:hidden" alt="ALPAY LOGO" />
    </div>
  );
}

export default Splash;
